<template>
  <div class="app-layout">
    <header class="app-header cf">
      <div class="container">
        <el-row>
          <el-col :span="5">
            <a href="/home" class="app-logo">
              <h1>分享收客</h1>
            </a>
          </el-col>
        </el-row>
      </div>
    </header>
    <main class="app-main cf">
      <router-view></router-view>
    </main>
    <footer class="app-footer">
      <p>Copyright(©) 2017 www.keketour.com 深圳市众游汇网络科技有限公司 All Rights Re</p>
      <a href="http://szcert.ebs.org.cn/CF52D6F1-F06A-4BEE-BD73-D7C41700F938" target="__blank">
        <img class="app-footer__" src="./img/bureau.jpg">
      </a>
    </footer>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.app-layout {
  margin: 0;
  padding: 0;
}

.app-header {
  position: relative;
  height: 90px;
  border-top: 4px solid #00BCD4;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16);
}

.app-logo {
  display: inline-block;
  color: transparent;
  margin: 10px 0;
  width: 185px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: -5px 0px;
  background-image: url(../assets/img/app-logo.png);
  background-size: contain;
  text-decoration: none;
  text-indent: -100%;
  overflow: hidden;
  margin-top: 17px;
}

.app-logo h1 {
  margin: 0;
}

.app-logo > a {
  color: #00BCD4;
  text-decoration: none;
}

.app-userInfo {
  line-height: 68px;
  font-size: 14px;
}

.app-main {
  background: #e9ecf1;
  min-height: 400px;
}

.app-footer {
  min-height: 120px;
  text-align: center;
  background-color: #fff;
  font-size: 16px;
  line-height: 38px;
  color: #000;
  overflow: hidden;
}

.app-footer img {
  width: 84px;
  height: 37px;
}
</style>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
}
.container-fuild {
  max-width: 1200px;
  min-width: 480px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// login.vue?9d34aaba